let videoModuleController = () => {
    require('../modules/jwplayer-infinite-scroll-module').on();
};

export default videoModuleController;
